"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVerifyAdminOtp = exports.useVerifyOtp = exports.useSendAdminOtp = exports.useSendOtp = exports.useResetPassword = exports.useUpdateProfile = exports.useUpdateUser = exports.useCreateUser = exports.useFetchUserById = exports.useFetchUserForFranchise = exports.useFetchUserForOwner = exports.useFetchUser = exports.useGetTokenWithRefreshToken = exports.useGetUserTokenWithRefreshToken = exports.useLogout = exports.useBusinessLogin = exports.useRegister = exports.useFOwnerLogin = exports.useAdminLogin = exports.useLogin = void 0;
const react_redux_1 = require("react-redux");
const userActions_1 = require("./userActions");
const store_1 = require("../xposProvider/store");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
const react_router_dom_1 = require("react-router-dom");
const useLogin = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const loading = (0, react_redux_1.useSelector)((state) => state['user/login'].loginLoading);
    const error = (0, react_redux_1.useSelector)((state) => state['user/login'].loginError);
    const loginUser = (loginData, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield dispatch((0, userActions_1.login)(loginData));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                onComplete(false, true, res);
            }
        }
        catch (error) {
            onComplete(false, true, error);
        }
    });
    return { loading, error, loginUser };
};
exports.useLogin = useLogin;
const useAdminLogin = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const loading = (0, react_redux_1.useSelector)((state) => state['user/adminLogin'].loginLoading);
    const error = (0, react_redux_1.useSelector)((state) => state['user/adminLogin'].loginError);
    const loginAdminUser = (loginData, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield dispatch((0, userActions_1.adminLogin)(loginData));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                onComplete(false, true, res);
            }
        }
        catch (error) {
            onComplete(false, true, error);
        }
    });
    return { loading, error, loginAdminUser };
};
exports.useAdminLogin = useAdminLogin;
const useFOwnerLogin = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const loading = (0, react_redux_1.useSelector)((state) => state['user/adminLogin'].loginLoading);
    const error = (0, react_redux_1.useSelector)((state) => state['user/adminLogin'].loginError);
    const loginFOwner = (loginData, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = yield dispatch((0, userActions_1.fOwnerLogin)(loginData));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                onComplete(false, true, res);
            }
        }
        catch (error) {
            onComplete(false, true, error);
        }
    });
    return { loading, error, loginFOwner };
};
exports.useFOwnerLogin = useFOwnerLogin;
const useRegister = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const loading = (0, react_redux_1.useSelector)((state) => state['user/register'].registerLoading);
    const error = (0, react_redux_1.useSelector)((state) => state['user/register'].registerError);
    const isRegister = (0, react_redux_1.useSelector)((state) => state['user/register'].isRegister);
    const registerUser = (registerData, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = (yield dispatch((0, userActions_1.register)(registerData)));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw res.error;
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return { loading, error, isRegister, registerUser };
};
exports.useRegister = useRegister;
const useBusinessLogin = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const loading = (0, react_redux_1.useSelector)((state) => state['user/businessLogin'].loginLoading);
    const error = (0, react_redux_1.useSelector)((state) => state['user/businessLogin'].loginError);
    const businessLoginUser = (token, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const res = (yield dispatch((0, userActions_1.businessLogin)(token)));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                onComplete(false, true, res);
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return { loading, error, businessLoginUser };
};
exports.useBusinessLogin = useBusinessLogin;
const useLogout = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const logoutUser = () => __awaiter(void 0, void 0, void 0, function* () {
        yield dispatch((0, userActions_1.logout)());
        dispatch((0, store_1.resetStore)());
    });
    return { logoutUser };
};
exports.useLogout = useLogout;
const useGetUserTokenWithRefreshToken = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const getUserTokenWithRefreshTokenFn = (token) => __awaiter(void 0, void 0, void 0, function* () {
        yield dispatch((0, userActions_1.getUserTokenWithRefreshToken)(token));
    });
    return { getUserTokenWithRefreshTokenFn };
};
exports.useGetUserTokenWithRefreshToken = useGetUserTokenWithRefreshToken;
const useGetTokenWithRefreshToken = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const getTokenWithRefreshTokenFn = (token) => __awaiter(void 0, void 0, void 0, function* () {
        yield dispatch((0, userActions_1.getTokenWithRefreshToken)(token));
    });
    return { getTokenWithRefreshTokenFn };
};
exports.useGetTokenWithRefreshToken = useGetTokenWithRefreshToken;
const useFetchUser = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userFetchloading = (0, react_redux_1.useSelector)((state) => state['user/fetch'].loading);
    const userFetchError = (0, react_redux_1.useSelector)((state) => state['user/fetch'].error);
    const userFetchData = (0, react_redux_1.useSelector)((state) => state['user/fetch'].data);
    const userFetch = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, userActions_1.fetch)(payload));
    });
    return {
        userFetchloading,
        userFetchError,
        userFetchData,
        userFetch
    };
};
exports.useFetchUser = useFetchUser;
const useFetchUserForOwner = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userFetchloading = (0, react_redux_1.useSelector)((state) => state['user/fetchForOwner'].loading);
    const userFetchError = (0, react_redux_1.useSelector)((state) => state['user/fetchForOwner'].error);
    const userFetchData = (0, react_redux_1.useSelector)((state) => state['user/fetchForOwner'].data);
    const userFetch = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, userActions_1.fetchForOwner)(payload));
    });
    return {
        userFetchloading,
        userFetchError,
        userFetchData,
        userFetch
    };
};
exports.useFetchUserForOwner = useFetchUserForOwner;
const useFetchUserForFranchise = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userFetchloading = (0, react_redux_1.useSelector)((state) => state['user/fetchForFranchise'].loading);
    const userFetchError = (0, react_redux_1.useSelector)((state) => state['user/fetchForFranchise'].error);
    const userFetchData = (0, react_redux_1.useSelector)((state) => state['user/fetchForFranchise'].data);
    const userFetch = (payload) => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, userActions_1.fetchForFranchise)(payload));
    });
    return {
        userFetchloading,
        userFetchError,
        userFetchData,
        userFetch
    };
};
exports.useFetchUserForFranchise = useFetchUserForFranchise;
const useFetchUserById = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userFetchByIdloading = (0, react_redux_1.useSelector)((state) => state['user/fetchById'].loading);
    const userFetchByIdError = (0, react_redux_1.useSelector)((state) => state['user/fetchById'].error);
    const userFetchByIdData = (0, react_redux_1.useSelector)((state) => state['user/fetchById'].data);
    const userFetchById = () => __awaiter(void 0, void 0, void 0, function* () {
        let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
        if (!userLogged) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, userActions_1.fetchUserById)());
    });
    return {
        userFetchByIdloading,
        userFetchByIdError,
        userFetchByIdData,
        userFetchById
    };
};
exports.useFetchUserById = useFetchUserById;
const useCreateUser = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userCreateloading = (0, react_redux_1.useSelector)((state) => state['user/create'].loading);
    const userCreateError = (0, react_redux_1.useSelector)((state) => state['user/create'].error);
    const userCreateData = (0, react_redux_1.useSelector)((state) => state['user/create'].data);
    const userCreate = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, userActions_1.create)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Failed to create user');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        userCreateloading,
        userCreateError,
        userCreateData,
        userCreate
    };
};
exports.useCreateUser = useCreateUser;
const useUpdateUser = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userUpdateloading = (0, react_redux_1.useSelector)((state) => state['user/update'].loading);
    const userUpdateError = (0, react_redux_1.useSelector)((state) => state['user/update'].error);
    const userUpdateData = (0, react_redux_1.useSelector)((state) => state['user/update'].data);
    const userUpdate = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, userActions_1.update)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw res;
            }
        }
        catch (error) {
            onComplete(false, true, error);
        }
    });
    return {
        userUpdateloading,
        userUpdateError,
        userUpdateData,
        userUpdate
    };
};
exports.useUpdateUser = useUpdateUser;
const useUpdateProfile = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userUpdateProfileloading = (0, react_redux_1.useSelector)((state) => state['user/updateUserProfile'].loading);
    const userUpdateProfileError = (0, react_redux_1.useSelector)((state) => state['user/updateUserProfile'].error);
    const userUpdateProfileData = (0, react_redux_1.useSelector)((state) => state['user/updateUserProfile'].data);
    const userUpdateProfile = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, userActions_1.updateUserProfile)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Failed to update user');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        userUpdateProfileloading,
        userUpdateProfileError,
        userUpdateProfileData,
        userUpdateProfile
    };
};
exports.useUpdateProfile = useUpdateProfile;
const useResetPassword = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userResetPasswordloading = (0, react_redux_1.useSelector)((state) => state['user/resetPassword'].loading);
    const userResetPasswordError = (0, react_redux_1.useSelector)((state) => state['user/resetPassword'].error);
    const userResetPasswordData = (0, react_redux_1.useSelector)((state) => state['user/resetPassword'].data);
    const userResetPassword = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, userActions_1.resetPassword)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Failed to update user');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        userResetPasswordloading,
        userResetPasswordError,
        userResetPasswordData,
        userResetPassword
    };
};
exports.useResetPassword = useResetPassword;
const useSendOtp = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userSendOtploading = (0, react_redux_1.useSelector)((state) => state['user/sendOtp'].loading);
    const userSendOtpError = (0, react_redux_1.useSelector)((state) => state['user/sendOtp'].error);
    const userSendOtpData = (0, react_redux_1.useSelector)((state) => state['user/sendOtp'].data);
    const userSendOtp = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = location.pathname == '/auth/sign-up' ||
                location.pathname == '/auth/reset-password'
                ? true
                : yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, userActions_1.sendOtp)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Failed to send otp');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        userSendOtploading,
        userSendOtpError,
        userSendOtpData,
        userSendOtp
    };
};
exports.useSendOtp = useSendOtp;
const useSendAdminOtp = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userSendOtploading = (0, react_redux_1.useSelector)((state) => state['user/sendAdminOtp'].loading);
    const userSendOtpError = (0, react_redux_1.useSelector)((state) => state['user/sendAdminOtp'].error);
    const userSendOtpData = (0, react_redux_1.useSelector)((state) => state['user/sendAdminOtp'].data);
    const userSendAdminOtp = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = location.pathname == '/auth/sign-up' ||
                location.pathname == '/auth/reset-password'
                ? true
                : yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, userActions_1.sendAdminOtp)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Failed to send otp');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        userSendOtploading,
        userSendOtpError,
        userSendOtpData,
        userSendAdminOtp
    };
};
exports.useSendAdminOtp = useSendAdminOtp;
const useVerifyOtp = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userVerifyOtploading = (0, react_redux_1.useSelector)((state) => state['user/verifyOtp'].loading);
    const userVerifyOtpError = (0, react_redux_1.useSelector)((state) => state['user/verifyOtp'].error);
    const userVerifyOtpData = (0, react_redux_1.useSelector)((state) => state['user/verifyOtp'].data);
    const userVerifyOtp = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = location.pathname == '/auth/sign-up' ||
                location.pathname == '/auth/reset-password'
                ? true
                : yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, userActions_1.verifyOtp)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Invalid otp or otp expired');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        userVerifyOtploading,
        userVerifyOtpError,
        userVerifyOtpData,
        userVerifyOtp
    };
};
exports.useVerifyOtp = useVerifyOtp;
const useVerifyAdminOtp = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const history = (0, react_router_dom_1.useNavigate)();
    const userVerifyOtploading = (0, react_redux_1.useSelector)((state) => state['user/verifyAdminOtp'].loading);
    const userVerifyOtpError = (0, react_redux_1.useSelector)((state) => state['user/verifyAdminOtp'].error);
    const userVerifyOtpData = (0, react_redux_1.useSelector)((state) => state['user/verifyAdminOtp'].data);
    const userVerifyAdminOtp = (payload, onComplete) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let userLogged = location.pathname == '/auth/sign-up' ||
                location.pathname == '/auth/reset-password'
                ? true
                : yield (0, AuthGuard_1.isLoggedIn)();
            if (!userLogged) {
                history('/auth/sign-in');
                return;
            }
            const res = yield dispatch((0, userActions_1.verifyAdminOtp)(payload));
            if (res.meta.requestStatus === 'fulfilled') {
                onComplete(true, false, res.payload);
            }
            else if (res.meta.requestStatus === 'rejected') {
                throw new Error('Invalid otp or otp expired');
            }
        }
        catch (error) {
            onComplete(false, true, error.message);
        }
    });
    return {
        userVerifyOtploading,
        userVerifyOtpError,
        userVerifyOtpData,
        userVerifyAdminOtp
    };
};
exports.useVerifyAdminOtp = useVerifyAdminOtp;
